import React from "react";
import { Star, Users, CalendarDays, BookUser, User } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearFlaggedQuestion } from "../../../../features/candidate-exam/candidate-exam-slice";
import toast from "react-hot-toast";
import { exams } from "../../../../api/exams";
import { useMutation } from "react-query";
import { differenceInDays } from "date-fns";
import Modal from "../../survey/components/Modal";
import DemographicsForm from "./Demographics";
const SurveyCard = ({ survey, refetch }: { survey: any, refetch: any }) => {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation();
  const [openModal, setOpenModal] = React.useState<boolean>(false);
  const user = JSON.parse(sessionStorage.getItem('user') || '{}')
  const isReview = location.pathname.includes("/candidate/my-review");
  const storedBranding = React.useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("branding") || '{}');
    } catch (error) {
      return null;
    }
  }, []);
  const appearance = storedBranding?.data?.appearance;

  const startSurvey = (data: any) => {
    const questionResponse = data?.data?.questions
    sessionStorage.setItem('survey-questions', JSON.stringify(questionResponse))
    sessionStorage.setItem('survey-user', 'employee')
    navigate('/candidate/survey')
  }

  const getQuestionsmutation = useMutation(exams.getExamQuestionsv2, {
    onSuccess: async (data: any) => {
      startSurvey(data)
    }
  })

  const getReviewerQuestionsmutation = useMutation(exams.getReviewerExamQuestionsv2, {
    onSuccess: async (data: any) => {
      startSurvey(data)
    }
  })

  const takeSurvey = (exam: any) => {
    if (exam?.requireDemographics && !exam?.hasFilledDemographics) {
      //console.log(exam, 'exam');
      setOpenModal(true)
      return
    }
    if (/*parseInt(exam?.progress) >= 100 || */  /* exam?.completed_at*/ false) return toast.error('You have already completed this survey');
    //  else if(new Date(exam?.end_date).getTime() < new Date().getTime()) return toast.error('This survey has been closed');
    dispatch(clearFlaggedQuestion(''));
    window.sessionStorage.setItem("assessment-type", isReview ? "review" : "survey");
    window.sessionStorage.setItem("active-assessment-id", exam?.user_exam_id);
    window.sessionStorage.setItem("active-assessment-user-id", exam?.user_id);
    window.sessionStorage.setItem("active-assessment", JSON.stringify(exam));
    if (isReview) {
      getReviewerQuestionsmutation.mutate({
        reviewerId: user?.user?.user_id || window.sessionStorage.getItem("user_id"),
        userId: exam?.user_id,
        userExamId: exam?.user_exam_id,
      });
    }
    else {
      getQuestionsmutation.mutate({
        userId: user?.user?.user_id || window.sessionStorage.getItem("user_id"),
        examId: exam?.user_exam_id,
        userExamId: exam?.user_id,
        showOnlyQuestions: true
      } as any);
    }
  }

  const viewResponse = (survey: any) => {
    sessionStorage.setItem('activeSurvey', JSON.stringify(survey))
    navigate(`/candidate/view-response`)
  }

  return (
    <div className="bg-white rounded-xl shadow-sm p-4 w-full  md:max-w-[320px]">
      {openModal &&
        <Modal
          closeModal={(value: any) => setOpenModal(value)}
          title=""
        >
          <div className="flex -mt-8 items-center gap-2">
            <DemographicsForm setOpen={setOpenModal} refetch={refetch} survey={survey} />
          </div>
        </Modal>

      }
      <div className="flex items-start justify-between">
        <h2 className="text-lg font-semibold text-gray-900">{survey?.group_title || survey?.survey_title}</h2>
        <div className="flex items-center gap-2">
          {
            parseInt(survey?.progress) === 0 ?
              <span className="bg-blue-100 w-[80px] text-center text-darkBlue text-xs font-medium px-1 py-0.5 rounded-full">
                Not Started
              </span>
              :
              (parseInt(survey?.progress) >= 100 || survey?.completed_at) ?
                <span className="bg-green-100 w-[80px] text-center text-primary text-xs font-medium px-1 py-0.5 rounded-full">
                  Completed
                </span>
                :
                <span className="bg-orange-100 w-[80px] text-center text-orange-500 text-xs font-medium px-1 py-0.5 rounded-full">
                  In Progress
                </span>
          }
        </div>
      </div>

      {/* Meta Info */}
      {/* <div className="flex items-center text-gray-500 text-md mt-3 gap-2">
        <BookUser className="w-4 h-4" />
        <span>{survey?.exam_title || survey?.survey_title}</span>
      </div> */}
      <div className="flex items-center text-gray-500 text-md mt-1 gap-2">
        <CalendarDays className="w-4 h-4" />
        <span>
          {(() => {
            const today = new Date();
            const endDate = new Date(survey?.end_date);
            const diff = differenceInDays(endDate, today);

            if (diff > 0) return `${diff} days left`;
            if (diff === 0) return "Ends today";
            return "Expired";
          })()}
        </span>
      </div>

      {location.pathname.includes("/candidate/my-review") &&
        <div className="flex items-center text-gray-500 text-md mt-3 gap-2">
          <User className="w-4 h-4" />
          <span>{survey?.user_name}</span>
        </div>
      }
      {location.pathname.includes("/candidate/my-review") &&
        <div className="flex items-center text-orange-500 text-md mt-3 gap-2" style={{ color: appearance?.theme_colour }}>
          <span>{survey?.review_type}</span>
        </div>
      }
      {/* !location.pathname.includes("/candidate/my-review") &&
        <div className="flex items-center text-gray-500 text-md mt-3 gap-2">
        Overall Rating:
        <span>{survey?.overall_rating || '-'}</span>
      </div>
       */}
      {/* !location.pathname.includes("/candidate/my-review") &&
        <>
          <div className="flex items-center font-semibold text-gray-500 text-md mt-3 gap-2">
            Rating By Section
          </div>
          { !survey?.sectionRatings?.length ? null :
            survey?.sectionRatings?.map((rating: any) => (
              <div className="flex items-center text-gray-500 text-md mt-2 gap-2">
              {rating?.sectionTitle} :
              <span>{rating?.averageRating || '-'}</span>
             </div>
            ))
          }
        </>
       */}
      {/* Progress */}
      <div className="mt-4">
        <div className="text-md text-gray-700 font-medium mb-1">Progress</div>
        <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
          <div style={{ width: `${parseInt(survey?.progress)}%`, backgroundColor: appearance?.theme_colour }} className="h-full bg-primary"></div>
        </div>
      </div>

      <div className={`${isReview ? 'flex justify-between' : ''} `}>
        {/* Continue Button */}
        <button id="take-survey" onClick={() => takeSurvey(survey)} style={{ backgroundColor: (!survey?.completed_at && appearance?.theme_colour) ? appearance.theme_colour : undefined }} className={`w-full mt-4 ${parseInt(survey?.progress) === 0 ? ' bg-orange-500' : /* parseInt(survey?.progress) >= 100 || */ survey?.completed_at ? 'bg-gray-300' : 'bg-orange-500'
          } text-white text-sm font-medium py-2 rounded-md flex justify-center items-center gap-2`}>
          <span>{
         /* parseInt(survey?.progress) === 0 || */ !survey?.completed_at ? isReview ? 'Evaluate' : 'Take Survey' : /*parseInt(survey?.progress) >= 100 ||*/ survey?.completed_at ? 'Completed' : 'Continue'}</span>
        </button>
        {false ? <button onClick={() => viewResponse(survey)} className={`w-full mt-4 bg-primary ml-5 text-white text-sm font-medium py-2 rounded-md flex justify-center items-center gap-2`}>
          View Response
        </button> : null}
      </div>
    </div>
  );
};

export default SurveyCard;
